<template>
    <nav class="navbar navbar-expand-lg navbar-light bg-secondary sticky-top">
        <div class="container">
            <a class="navbar-brand mr-auto mr-lg-0 text-white brand-font" href="#">Promeraia</a>
            <button class="navbar-toggler p-0 border-0" type="button" data-toggle="collapse" data-target="#navbar-menu"
                    aria-controls="navbar-menu" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>

            <div class="collapse navbar-collapse text-white" id="navbar-menu" v-show="getUserLoadStatus == 2">
                <ul class="navbar-nav ml-auto">
                        <li class="nav-item"><a class="nav-link text-white" id="homeUrl" href="/admin/projs/home"><i class="fas fa-jedi"></i>&nbsp;案件</a></li>
                        <!-- <li class="nav-item"><a class="nav-link text-white" href="/admin/tech"><i class="fas fa-id-badge"></i>&nbsp;技術者一覧</a></li> -->
                        <!-- <li class="nav-item"><a class="nav-link text-white" href="/mail/trade"><i class="fas fa-envelope"></i>&nbsp;全体メール</a></li> -->
                        <!-- <li class="nav-item"><a class="nav-link text-white" href="/analysis/post"><i class="fas fa-chart-line"></i>&nbsp;アクセス情報</a></li> -->
                        <li class="nav-item"><a class="nav-link text-white" href="/admin/apply"><i class="fas fa-comment-alt"></i>&nbsp;応募情報</a></li>
                        <li class="nav-item"><a class="nav-link text-white" href="/admin/invites"><i class="fas fa-leaf"></i>&nbsp;招待</a></li>
                        <li class="nav-item"><a class="nav-link text-white" href="/admin/setting"><i class="fas fa-cog"></i>&nbsp;各種設定</a></li>
                </ul>

                <ul class="navbar-nav">
                    <li class="nav-item" v-if="!getUser"><a class="nav-link text-white" href="/login"><i class="fas fa-sign-in-alt"></i>&nbsp;Login</a></li>
                    <li class="nav-item dropdown" v-else>
                        <a href="#" class="nav-link dropdown-toggle text-white" data-toggle="dropdown" role="button"
                           aria-expanded="false">
                            <i class="fas fa-user"></i>{{this.getUser.name}}
                            <span class="caret"></span>
                        </a>
                        <div class="dropdown-menu" role="menu">
                            <a class="dropdown-item" href="/logout">
                                <i class="fas fa-door-open"></i>   ログアウト</a>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</template>

<script>
    import {mapGetters} from 'vuex'

    import {EventBus} from 'js/event-bus'

    export default {
        mounted () {
            EventBus.$on('routerToHome', () => {
                location.href = $('#homeUrl').attr('href')
            })
        },
        computed: {
            ...mapGetters(['getUser']),
            ...mapGetters(['getRole']),
            ...mapGetters(['getUserLoadStatus'])
        }
    }
</script>

<style>

</style>
